<template>
  <div class="com-box">
    <div class="title">推荐门店</div>
    <div class="list">
      <img src="https://img3.quanyou.com.cn/joy/group1/M00/10/0E/rB4ChWJ5xTOAGG0sAAAHXe6sweQ927.png" />
      <p>当前为预览活动，暂无门店</p>
      <img src="https://img3.quanyou.com.cn/joy/group1/M00/10/0E/rB4ChWJ5xmWATf9YAAAKd_VZeb0109.png" />
    </div>
    <div class="list address">
      <img src="https://img3.quanyou.com.cn/joy/group1/M00/10/0C/rB4ChmJ5x82AE64CAAALma12c7A979.png" />
      <p>当前为预览活动，暂无门店</p>
    </div>
    <!-- <div class="bottom-box">更多门店</div> -->
  </div>
</template>

<script>
export default {
}
</script>

<style lang="stylus" scoped>
.com-box {
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 230px;
  margin-top: 10px;
  background: url('https://img3.quanyou.com.cn/joy/group1/M00/10/0D/rB4ChWJ5wMyAUrt8AAHI3vwlcbU350.png');
  background-size: 100% 100%;
  .title {
    color: #FFFFFF;
    font-size: 13px;
    font-weight: bold;
    margin-top: 16px;
  }
  .list {
    display: flex;
    justify-content: cneter;
    align-items: center;
    width: 264px;
    padding: 0 5px;
    color: #F53F4C;
    font-size: 12px;
    background: #FFE2CB;
    box-shadow: 0 2px 6px 0 rgba(236, 163, 150, 0.39);
    border-radius: 5px;
    margin-top: 20px;
    img {
      width: 22px;
      height: 22px;
    }
    p {
      width: 204px;
      margin-left: 5px;
    }
  }
  .address {
    text {
      width: 235px;
      margin-left: 5px;
    }
  }
  .bottom-box {
    width: 62px;
    height: 16px;
    font-size: 12px;
    color: #F53F4C;
    text-align: center;
    line-height: 16px;
    border: 1px solid #F53F4C;
    border-radius: 8px;
    margin-top: 16px;
  }
}
</style>